import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container, Button } from "@material-ui/core";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/route";
import Logo from "../../contents/img/Rampver_Online_Logo-main.png";

class VerifyEmail extends Component {
  state = { emailSent: false, error: null };

  handleResend = () => {
    this.props.firebase
      .doSendEmailVerificationLink()
      .then(() => this.setState({ emailSent: true, error: null }))
      .catch((err) => this.setState({ error: err.message }));
  };

  handleSignOut = () => {
    this.props.firebase.doSignOut();
    this.props.history.push(ROUTES.SIGN_IN);
  };

  render() {
    const { emailSent, error } = this.state;

    return (
      <Container>
        <div id="message" className="r-title-container text-center">
          <img
            src={Logo}
            alt="rampver-logo"
            style={{ height: "auto", width: "300px" }}
          />
          <br />
          <p className="r-title">Please verify your email</p>
          <p className="r-subtitle">
            You need to verify your email before accessing Rampver Online.
            Please check your inbox and click the verification link we sent you.
          </p>
          {emailSent && (
            <p className="r-subtitle" style={{ color: "#256141" }}>
              Verification email sent! Please check your inbox.
            </p>
          )}
          {error && (
            <p className="r-subtitle" style={{ color: "#c0392b" }}>
              {error}
            </p>
          )}
          <br />
          <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
            <Button
              onClick={this.handleResend}
              variant="contained"
              color="secondary"
              disabled={emailSent}
              style={{ color: "white", padding: "10px 32px" }}
            >
              {emailSent ? "Email Sent" : "Resend Verification Email"}
            </Button>
            <Button
              onClick={this.handleSignOut}
              variant="outlined"
              style={{ padding: "10px 32px" }}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </Container>
    );
  }
}

export default compose(withRouter, withFirebase)(VerifyEmail);
